<template lang="pug">
Loading(v-if="showLoading")
Error(v-else-if="showError" :msg="errorMsg")
.get-reward-page(v-else)
  .get-reward-container
    img.img-block(src="https://m.hellobike.com/59fd96cb_Slice%20143.png")
    .get-content
      //- .good-text {{ days }}
      img.good-img(src="https://m.hellobike.com/8fde7abe_30%202.png")
      img.img-block(src="https://m.hellobike.com/fc1472a9_Slice%20144.png")
      img.get-btn(:src="getBtnImg" @click="handleGetReward")
    img.img-block(src="https://m.hellobike.com/80d38c61_Slice%20145.png")
</template>

<script>
import { receiveActivityCoupon, getHaCommandPageInfo } from '@/api/tiktokSign';
import Toast from '@/components/toast';
import { getTokenAndLocation } from '@/utils';
import { getSystemCode, getVersion } from '@/utils/systemCode';
import { Navigator } from '@hb/h5-navigator';
import { UBTUtils } from '@/utils/ubt';
import config from '@/const/config';
import { EVENT_CODE, PRIZE_STATUS } from './const';

import Error from './components/error';
import Loading from './components/loading';

export default {
  name: 'GetRewardPage',
  components: {
    Loading,
    Error,
  },
  data() {
    return {
      showLoading: true,
      showError: false,
      btnLock: false,
      days: '30',
      activityCode: '',
      prizeCode: '',
      prizeName: '',
      status: null,
      errorMsg: '暂无可参与的优惠活动',
    };
  },

  computed: {
    getBtnImg() {
      // eslint-disable-next-line no-console
      console.log('getBtnImg', this.status === 1 ? 'https://m.hellobike.com/bba9e85d_Group%201739333001.png' : 'https://m.hellobike.com/d4d0ef89_Frame%2020828935891.png');
      return this.status === 1 ? 'https://m.hellobike.com/bba9e85d_Group%201739333001.png' : 'https://m.hellobike.com/d4d0ef89_Frame%2020828935891.png';
    },
  },
  async created() {
    await this.init();
    this.showLoading = false;
  },
  destroyed() {
    this.handleSPM('viewOut');
  },
  methods: {
    async init() {
      this.getActivityInfo();
    },
    handleSPM(type) {
      const { activityCode } = this;
      const commonParams = {
        activityCode,
      };

      const pageId = 'platform_huandianwx_activity';

      if (type === 'view') {
        UBTUtils.pageView({
          pageId,
          categoryId: 'platform',
          businessInfo: { ...commonParams },
        });
      } else if (type === 'click') {
        UBTUtils.clickButton({
          pageId,
          buttonName: 'platform_huandianwx_activity_buttun',
          categoryId: 'platform',
          businessInfo: { ...commonParams },
        });
      } else if (type === 'viewOut') {
        UBTUtils.pageViewOut({
          pageId,
          categoryId: 'platform',
          businessInfo: { ...commonParams },
        });
      } else if (type === 'moduleExpose') {
        // 模块曝光
        UBTUtils.moduleExpose({
          pageId,
          moduleId: 'platform_huandianwx_activity_buttun',
          contentId: 'platform_huandianwx_activity_buttun',
          exposureTimes: 1,
          categoryId: 'platform',
          businessInfo: { ...commonParams },
        });
      }
    },
    jumpHacodePage() {
      if (!this.prizeCode) {
        Toast.show('缺少必要参数');
        return;
      }
      const url = `https://m.hellobike.com/AppPlatformH5/${config.envUrlMixin}latest/index.html#/tw-card-active?adsource=swapHa&batchCode=${this.prizeCode}`;
      Navigator.go(url);
    },

    async getActivityInfo() {
      const { adsource } = this.$route.query;
      const {
        token, cityCode, adCode, lng, lat,
      } = await getTokenAndLocation();
      const params = {
        code: EVENT_CODE.SWAP_BATTERY,
        token,
        cityCode,
        adCode,
        lng,
        lat,
        tag: '',
        params: {
          adSource: adsource,
        },
      };
      try {
        const {
          data: {
            componentData = {},
          },
        } = await getHaCommandPageInfo(params);
        const {
          prizeCode, prizeName, status, activityCode,
        } = componentData;
        this.activityCode = activityCode;
        this.prizeCode = prizeCode;
        this.prizeName = prizeName;
        this.status = status;
        const validStatuses = [PRIZE_STATUS.CAN_RECEIVE, PRIZE_STATUS.ALREADY_RECEIVED];
        if (!this.activityCode || !validStatuses.includes(this.status)) {
          this.showError = true;
        } else {
          // 埋点上报
          this.handleSPM('view');
          // 模块曝光
          this.handleSPM('moduleExpose');
        }
      } catch (error) {
        this.showError = true;
      }
    },
    async handleGetReward() {
      if (this.btnLock) return;
      this.handleSPM('click');
      this.btnLock = true;
      try {
        if (this.status === PRIZE_STATUS.ALREADY_RECEIVED) {
          this.jumpHacodePage();
          return;
        }
        const { token, adCode, cityCode } = await getTokenAndLocation();
        const param = {
          token,
          adCode,
          cityCode,
          activityCode: this.activityCode,
          eventCode: EVENT_CODE.SWAP_BATTERY,
          systemCode: getSystemCode(),
          version: await getVersion(),
        };
        const res = await receiveActivityCoupon(param);
        if (res.code === 0) {
          Toast.show('领取成功');
          // eslint-disable-next-line no-console
          console.log('receiveActivityCoupon res', res);
          setTimeout(() => {
            this.jumpHacodePage();
          }, 2000);
        } else {
          Toast.show('领取失败，请稍后重试。');
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('handleGetReward => error', error);
        Toast.show('领取失败，请稍后重试。');
      } finally {
        this.btnLock = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
// @font-face {
//   font-family: 'AlimamaFangYuanTiVF';
//   src: url('https://m.hellobike.com/6b503fe7_AlimamaFangYuanTiVF-Thin.ttf') format('truetype');
//   font-style: normal;
//   font-variation-settings: "wght" 700, "BEVL" 100;
// }

.get-reward-page {
  background-color: #daf8ff;
  min-height: 100vh;
  overflow-y: auto;

  .img-block {
    display: block;
    width: 100%;
    height: auto;
  }

  .get-reward-container {
    .get-content {
      position: relative;

      .get-btn {
        position: absolute;
        right: 0.49rem;
        top: 0.85rem;
        width: 0.99rem;
        height: 0.55rem;
      }

      .good-img {
        position: absolute;
        top: 0.75rem;
        left: 0.54rem;
        width: 0.64rem;
        height: 0.47rem;
      }

      // .good-text {
      //   position: absolute;
      //   top: 0.66rem;
      //   left: 0.46rem;
      //   font-weight: 700;
      //   font-size: 0.6rem;
      //   line-height: 0.65rem;
      //   color: #fe0701;
      //   font-family: AlimamaFangYuanTiVF, PingFang SC, Arial, sans-serif;
      // }
    }
  }
}
</style>
